import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Content = styled.div `
  min-width: ${pxToRem(300)};
  padding: ${themeGet('spacing.xl')} ${themeGet('spacing.xl')} 0;
`;
